/* eslint-disable no-use-before-define */

const API_URL = Symbol('apiUrl');
const $HTTP = Symbol('$http');
const $Q = Symbol('$q');
const DEVICE_ID = Symbol('deviceId');
const TOKEN = Symbol('token');

class ApiService {
  static factory($q, $http, deviceDetector, apiUrl) {// eslint-disable-line no-unused-vars
    'ngInject';
    return new ApiService(...arguments);
  }

  constructor($q, $http, deviceDetector, apiUrl) {
    this[$Q] = $q;
    this[$HTTP] = $http;
    this[API_URL] = `${apiUrl}/api/1.0`;
    this[TOKEN] = '';
    this[DEVICE_ID] = deviceDetector.device === 'unknown'
      ? deviceDetector.browser
      : deviceDetector.device;
  }

  userLogin(email, password) {
    const deviceId = this[DEVICE_ID];

    return this.post('login', { deviceId, email, password }).then(res => {
      this[TOKEN] = res.token;
      return res;
    });
  }

  userRegister(name, email, password) {
    return this.post('register', { name, email, password });
  }

  userCreate(name, email, password, company, timezone, trackingMode, referrer = '') {
    return this.post('register/signup', {
      name, email, password, company, timezone, trackingMode, referrer, noWorkspaces: 1,
    });
  }

  authorization() {
    return this.get('authorization', { 'no-workspaces': 1 });
  }

  companyCreate(name, timeZone, trackingType) {
    return this.post('companies', { name, timeZone, trackingType });
  }

  companyUpdate(id, params) {
    return this.put(`companies/${id}`, params);
  }

  timezoneDetect() {
    return this.get(
      'https://btnhr9r871.execute-api.us-east-1.amazonaws.com/production/timezone-detect',
      {},
      {},
      false
    );
  }

  ownManagedUsers(company) {
    return this.get('users/me/managed', {
      company,
    });
  }

  getToken() {
    return this[TOKEN];
  }

  setToken(token) {
    this[TOKEN] = token;
    return this;
  }

  get(ep, query = {}, useToken = true) {
    return this.request('get', ep, query, {}, useToken);
  }

  post(ep, data, query = {}, useToken = true) {
    return this.request('post', ep, query, data, useToken);
  }

  put(ep, data, query = {}, useToken = true) {
    return this.request('put', ep, query, data, useToken);
  }

  request(method, ep, query = {}, data = {}, useToken = true) {
    let request;
    const url = this.endpoint(ep);
    const deferred = this[$Q].defer();
    const config = {
      params: query,
    };

    if (this[TOKEN] && useToken) {
      config.params.token = this[TOKEN];
    }

    if (method === 'get') {
      request = this[$HTTP][method](url, config);
    } else {
      request = this[$HTTP][method](url, data, config);
    }

    request.then(res => {
      resolve(deferred, res);
    }).catch(deferred.reject);

    return deferred.promise;
  }

  endpoint(ep) {
    let url = ep;

    if (!/^https?:\/\//i.test(ep)) {
      url = `${this[API_URL]}/${ep}`;
    }

    return url;
  }
}

function resolve(promise, res) {
  if (res.data && res.data.data) {
    promise.resolve(res.data.data);
  } else if (res.data) {
    promise.resolve(res.data);
  } else {
    promise.resolve(res);
  }
}

export default ApiService;
